export default {
  title: 'Gerir conta',
  buttons: {
    save: 'Guardar',
    delete: 'Eliminar',
  },
};
